<template>
  <div class="right show-under1460">
  <slot></slot>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
    }
  },
  created() {
  	
  },
  mounted(){
  	var elemss = this.$el.querySelectorAll('.dropdown-trigger');
    M.Dropdown.init(elemss, {closeOnClick: false});
  },
  methods: {
},

}
</script>

<style scoped>
nav li.menuitems {
    text-transform: uppercase;
    width: 130px;
    text-align: center !important;
    margin-top: 16px;
    background-color: #BEBBBB;
    height: 84px;
}
div{
	width: 200px;
}
.dropdown-content li.menuitems {
    margin-top: 0px;
    width: 100%;
    height: 20px;

}
li.menuitems > a {
	height: 100% !important;
  padding-top: 10px;
  text-align: left;
  line-height: 1.7;
}
/deep/ .menuitems i.material-icons {
  padding-top: 0px;
  margin-right: 10px;
  padding-left: 10px;
  line-height: 1.5;
}
</style>
